import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
import { Personal } from '../../models/personal';
import { DataService } from '../../utils/data.service';
import { MatDialog } from '@angular/material';
import { modalComponent } from '../../utils/modal/modal.component';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'my-personal-detalle',
  styleUrls: [], 
  templateUrl: 'personal-detalle.component.html',
  providers: [generalService]
})
export class PersonalDetalleComponent implements OnInit {
	/***************************INFINITE SELECT**********************************/
	public viewDataPersonal: any[];
	@ViewChild('infiniteSelect') selectElem: MatSelect;
	private itemsShow = 10;
  	/***************************INFINITE SELECT**********************************/

 @Input() personal: Personal;
formPersonal: FormGroup;
titulo = "";
isUpdate: boolean;
person_id: string;
list: any;
reader: FileReader;
public personalcopy: Personal;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private route: ActivatedRoute,
		private _generalService: generalService, 
		public dataService: DataService, 
		public dialog: MatDialog
		) {
		this.list = new Object();
		this.personal = new Personal();
		this.personalcopy = new Personal();
		this.formPersonal = new FormGroup({});
		this.person_id = this.route.snapshot.paramMap.get('id');
		//Usar en caso de emergencia con el router
		// this.router.events.subscribe(path => {
		//   console.log('path = ', path);
		// });
		//Init lists.
		this.list.DaysOfRest = [
			{CODE: 'Do' , MEANING: 'Domingo'},
			{CODE: 'Lu' , MEANING: 'Lunes'},
			{CODE: 'Ma' , MEANING: 'Martes'},
			{CODE: 'Mi' , MEANING: 'Miercoles'},
			{CODE: 'Ju' , MEANING: 'Jueves'},
			{CODE: 'Vi' , MEANING: 'Viernes'},
			{CODE: 'Sa' , MEANING: 'Sabado'}
		];

		this.list.WorkShift = [
			{CODE: 'M' , MEANING: 'Matutino'},
			{CODE: 'V' , MEANING: 'Vespertino'},
			{CODE: 'C' , MEANING: 'Cubredescansos'},
			{CODE: '24', MEANING: '24 Horas'},
		];

		this.list.Gender = [
			{CODE: 'M' , MEANING: 'Masculino'},
			{CODE: 'F' , MEANING: 'Femenino'}
		];
	}

	ngOnInit() {
		this.buildForm();
		this.initNewOrUpdate();		
		//Reload page when id changes
		this.route.params.subscribe(params => {
			if(this.person_id != params['id']){
		    	this.person_id = params['id'];
		    	this.initNewOrUpdate();// reset and get based on new :id
			}
		});
		/***************************INFINITE SELECT**********************************/
	    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent());
	    /***************************INFINITE SELECT**********************************/
  	}

  	getPersonal(id:any){
	    this._generalService.metodoCall(`personal/consultarPersonal/${id}`).subscribe(
	        result => {
        		let res = JSON.parse(result);
	        	if(res.some(e => true)){
	        		this.personal = res[0];        		
	        		let payImss:any = this.personal.PAY_IMSS;
	        		this.personal.PAY_IMSS = (payImss == 1);
	        		let infonavitFlag:any = this.personal.INFONAVIT_FLAG;
	        		this.personal.INFONAVIT_FLAG = (infonavitFlag == 1);
	        		this.titulo = `Expediente Técnico de ${this.personal.NAME} ${this.personal.LAST_NAME}`;
	        		this.isUpdate = true;
	        		let src = this.personal.PHOTO_BASE64 ? `data:image/png;base64, ${this.personal.PHOTO_BASE64}` : `assets/images/person.jpg`;
            		$('#personalImage').attr('src', src);
            		if(this.personal.WAY_TO_PAY == "T")
            			this.formPersonal.get('CARD_NUMBER').enable();

					this.personalcopy = JSON.parse(JSON.stringify(this.personal));
					if(this.personalcopy.DATE_OF_BIRTH !== null) {
						this.personalcopy.DATE_OF_BIRTH = new Date(this.personalcopy.DATE_OF_BIRTH);
					}
					if(this.personalcopy.START_DATE !== null) {
						this.personalcopy.START_DATE = new Date(this.personalcopy.START_DATE);
					}
					if(this.personal.DATE_OF_BIRTH !== null) {
						this.personal.DATE_OF_BIRTH = new Date(this.personal.DATE_OF_BIRTH);
					}
					if(this.personal.START_DATE !== null) {
						this.personal.START_DATE = new Date(this.personal.START_DATE);
					}
	        		
            		//this.personalcopy = this.personal;
	        	}
	        	else
    				this.router.navigate(['../', 'N'], {relativeTo: this.route });
          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
  	}

  	getInit(){
		let personal = new Personal();
		personal.loacs = sessionStorage.getItem('acslo');
  		this._generalService.metodoCallParams(personal,"personal/getInit/").subscribe(
	        result => {	        	
        		let res = JSON.parse(result);
	        	//this.list.Gender = res.Table;
	        	this.list.CivilStatus = res.Table;
	        	this.list.Country = res.Table1;
	        	this.list.EmployeeType = res.Table2;
	        	this.list.NoIMSS = res.Table3;
	        	this.list.Customer = res.Table4;
	        	/***************************INFINITE SELECT**********************************/
	            this.viewDataPersonal = this.list.Customer.slice(0, 10);
	            /***************************INFINITE SELECT**********************************/
	        	this.list.Periodicity = res.Table5;
          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
  	}

  	getEstado(pais:any){
  		if(!pais)
  			return;
  		this._generalService.metodoCall(`misc/consultarEstado/${pais}`).subscribe(
	        result => {
	        	this.list.State = JSON.parse(result);
          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
  	}

  	getCiudad(estado:any){
  		if(!estado)
  			return;
  		this._generalService.metodoCall(`misc/consultarCiudad/${estado}`).subscribe(
	        result => {
	        	this.list.City = JSON.parse(result);
          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
  	}

  	getSites(customer:any){
  		if(!customer)
  			return;
  		this._generalService.metodoCall(`misc/consultarUbicaciones/${customer}`).subscribe(
	        result => {
	        	this.list.Sites = JSON.parse(result);
          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
  	}

  	updatePersonal(){
		console.log(this.personal);
		this.personal.loacs = sessionStorage.getItem("acslo");
  		this._generalService.metodoCallParams(this.personal, "personal/actualizarPersonal").subscribe(
          result => {
          	if(result == "El RFC ingresado para el personal ya se encuentra registrado en otro personal")
          	{
          		this.modal("alert", result);
          	}else{
          		this._generalService.toastCall(result.message);
				  this.personalcopy = JSON.parse(JSON.stringify(this.personal));
				if (this.personalcopy.DATE_OF_BIRTH !== undefined && this.personalcopy.DATE_OF_BIRTH !== null){
					this.personalcopy.DATE_OF_BIRTH = new Date(this.personalcopy.DATE_OF_BIRTH);
				}
				if (this.personalcopy.START_DATE !== undefined && this.personalcopy.START_DATE !== null){
					this.personalcopy.START_DATE = new Date(this.personalcopy.START_DATE);
				}
				if (this.personal.DATE_OF_BIRTH !== undefined && this.personal.DATE_OF_BIRTH  !== null){
					this.personal.DATE_OF_BIRTH = new Date(this.personal.DATE_OF_BIRTH);
				}
				if (this.personal.START_DATE !== undefined && this.personal.START_DATE !== null){
					this.personal.START_DATE = new Date(this.personal.START_DATE);
				}
          	}
          },
          error => {
            console.log(<any>error);
          }
      ); 
  	}

  	modal(tipo, mensaje){
	    this.dataService.modal = tipo;
	    this.dataService.mensaje = mensaje;
	    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
	    this.dataService.dialogModal = dialogModal;
	    dialogModal.afterClosed().subscribe((result) => {
	        
	    });
	  }

  	createPersonal(){
		this.personal.loacs = sessionStorage.getItem("acslo");
  		this._generalService.metodoCallParams(this.personal, "personal/agregarPersonal").subscribe(
          result => {
          	if(result == "El RFC ingresado para el personal ya se encuentra registrado en otro personal")
          	{
          		this.modal("alert", result);
          	}else{
          		this._generalService.toastCall(result.message);
				this.router.navigate(['../', result.data], {relativeTo: this.route });
			}
          },
          error => {
            console.log(<any>error);
          }
      ); 
  	}

  	getPersonalCardNumber(id:any){
  		this._generalService.metodoCall(`personal/consultarPersonalCardNumber/${id}`).subscribe(
          result => {
          	this.personal.CARD_NUMBER = result;
          },
          error => {
            console.log(<any>error);
          }
      	); 
  	}

  	getPersonalIMSS(id:any){
  		this._generalService.metodoCall(`personal/consultarPersonalIMSS/${id}`).subscribe(
          result => {
          	this.personal.IMSS_TAX = result;
          },
          error => {
            console.log(<any>error);
          }
      	); 
  	}

  	getPersonalInfonavit(id:any){
  		this._generalService.metodoCall(`personal/consultarPersonalInfonavit/${id}`).subscribe(
          result => {
          	this.personal.INFONAVIT = result;	
          },
          error => {
            console.log(<any>error);
          }
      	); 
  	}

  	checkFormaDePago(event:any){
  		const ctrl = this.formPersonal.get('CARD_NUMBER');
  		if(event.value == 'T'){
  			this.getPersonalCardNumber(this.person_id);
  			ctrl.enable();
  		}
  		else{
  			this.personal.CARD_NUMBER = "";
  			ctrl.disable();
  		}
  	}

  	checkIMSS(event:any){
  		const ctrl = this.formPersonal.get('IMSS_TAX');
  		const ctrl2 = this.formPersonal.get('REASON_NOT_IMSS');
  		this.personal.PAY_IMSS = event.checked;
  		if(event.checked){
  			this.getPersonalIMSS(this.person_id);
  			this.personal.REASON_NOT_IMSS = null;
  			ctrl.enable();
  			//ctrl2.disable();
  		}
  		else{
  			this.personal.IMSS_TAX = null;
  			//ctrl2.enable();
  			ctrl.disable();
  		}
  	}

  	checkInfonavit(event:any){
  		const ctrl = this.formPersonal.get('INFONAVIT');
  		this.personal.INFONAVIT_FLAG = event.checked;
  		if(event.checked){
  			this.getPersonalInfonavit(this.person_id);  			
  			ctrl.enable();
  		}
  		else{
  			this.personal.INFONAVIT = null;
  			ctrl.disable();
  		}
  	}

  	onSubmit() {      
  	  if(this.isUpdate)
  	  	this.updatePersonal();
  	  else
  	  	this.createPersonal();
      
  	}

  	actualizarMensaje(){
	    this.dataService.modal = "confirm";
	    this.dataService.mensaje = "¿Desea descartar los cambios del personal?";
	    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
	    this.dataService.dialogRef = dialogModal;
	    dialogModal.afterClosed().subscribe((result) => {
	        if(this.dataService.guardado)
	        {
	        	this.router.navigate(['/app/personal']);
	        }
	    });
	}

	regresar(){
		if (this.personal.DATE_OF_BIRTH == undefined){
			this.router.navigate(['/app/personal']);
		}
		else{
			let nacimientop = (this.personal.DATE_OF_BIRTH._d) ? this.personal.DATE_OF_BIRTH._d : this.personal.DATE_OF_BIRTH;
			let nacimientoc = (this.personalcopy.DATE_OF_BIRTH._d) ? this.personalcopy.DATE_OF_BIRTH._d : this.personalcopy.DATE_OF_BIRTH;
			let iniciop = (this.personal.START_DATE._d) ? this.personal.START_DATE._d : this.personal.START_DATE;
			let inicioc = (this.personalcopy.START_DATE._d) ? this.personalcopy.START_DATE._d : this.personalcopy.START_DATE;

			if(
				this.personal.NAME != this.personalcopy.NAME ||
				this.personal.LAST_NAME != this.personalcopy.LAST_NAME ||
				this.personal.MOTHER_LAST_NAME != this.personalcopy.MOTHER_LAST_NAME ||
				nacimientop.getTime() != nacimientoc.getTime() ||
				iniciop.getTime() != inicioc.getTime() ||
				this.personal.CIVIL_STATUS != this.personalcopy.CIVIL_STATUS ||
				this.personal.GENDER != this.personalcopy.GENDER ||
				this.personal.RFC != this.personalcopy.RFC ||
				this.personal.CURP != this.personalcopy.CURP ||
				this.personal.MILITARY != this.personalcopy.MILITARY ||
				this.personal.IMSS != this.personalcopy.IMSS ||
				this.personal.COUNTRY_ID != this.personalcopy.COUNTRY_ID ||
				this.personal.STATE_ID != this.personalcopy.STATE_ID ||
				this.personal.CITY_ID != this.personalcopy.CITY_ID ||
				this.personal.ADDRESS != this.personalcopy.ADDRESS ||
				this.personal.COUNTY != this.personalcopy.COUNTY ||
				this.personal.ZIP_CODE != this.personalcopy.ZIP_CODE ||
				this.personal.HOME_PHONE != this.personalcopy.HOME_PHONE ||
				this.personal.CELL_PHONE != this.personalcopy.CELL_PHONE ||
				this.personal.EMAIL != this.personalcopy.EMAIL ||
				this.personal.EMPLOYEE_NUMBER != this.personalcopy.EMPLOYEE_NUMBER ||
				this.personal.EMPLOYEE_TYPE != this.personalcopy.EMPLOYEE_TYPE ||
				this.personal.AR_CUSTOMER != this.personalcopy.AR_CUSTOMER ||
				this.personal.PERIODICITY != this.personalcopy.PERIODICITY ||
				this.personal.AMOUNT != this.personalcopy.AMOUNT ||
				this.personal.SHIRT_SIZE != this.personalcopy.SHIRT_SIZE ||
				this.personal.JEANS_SIZE != this.personalcopy.JEANS_SIZE ||
				this.personal.SHOE_SIZE != this.personalcopy.SHOE_SIZE ||
				this.personal.PHOTO_BASE64 != this.personalcopy.PHOTO_BASE64 ||
				this.personal.Text1 != this.personalcopy.Text1 ||
				this.personal.WAY_TO_PAY != this.personalcopy.WAY_TO_PAY ||
				this.personal.CARD_NUMBER != this.personalcopy.CARD_NUMBER ||
				this.personal.WORKSHIFT != this.personalcopy.WORKSHIFT ||
				this.personal.DAY_OF_REST != this.personalcopy.DAY_OF_REST ||
				this.personal.PAY_IMSS != this.personalcopy.PAY_IMSS ||
				this.personal.IMSS_TAX != this.personalcopy.IMSS_TAX ||
				this.personal.INFONAVIT_FLAG != this.personalcopy.INFONAVIT_FLAG ||
				this.personal.INFONAVIT != this.personalcopy.INFONAVIT ||
				this.personal.REASON_NOT_IMSS != this.personalcopy.REASON_NOT_IMSS ||
				this.personal.SITE_ID != this.personalcopy.SITE_ID ||
				this.personal.PRIZE != this.personalcopy.PRIZE
			  )
			{
				this.actualizarMensaje();
			}
			else{
				this.router.navigate(['/app/personal']);
			}
		}
	}

  	initNewOrUpdate(){
  		this.getInit();		
		if(this.person_id == 'N'){
			this.titulo = "Nuevo Expediente Técnico"
			this.isUpdate = false;
			this.personal = new Personal();
		}
		else
    		this.getPersonal(this.person_id);  		
  	}

  	updateImage(fileInput :any){
  		if (!(fileInput.target.files && fileInput.target.files[0]))
  			return; 
  		var self = this;
        var reader = new FileReader();
		reader.onload = function (e : any) {
            $('#personalImage').attr('src', e.target.result);
            //Image
            var image = new Image();
      		image.src = reader.result as string;

  			image.onload = function() {
				var maxWidth = 960,
		        maxHeight = 960,
		        imageWidth = image.width,
		        imageHeight = image.height;

			    if (imageWidth > imageHeight) {
			      if (imageWidth > maxWidth) {
			        imageHeight *= maxWidth / imageWidth;
			        imageWidth = maxWidth;
			      }
			    }
			    else {
			      if (imageHeight > maxHeight) {
			        imageWidth *= maxHeight / imageHeight;
			        imageHeight = maxHeight;
			      }
			    }

			    var canvas = document.createElement('canvas');
			    canvas.width = imageWidth;
			    canvas.height = imageHeight;

			    var ctx = canvas.getContext("2d");
			    ctx.drawImage(image, 0, 0, imageWidth, imageHeight);

			    self.personal.PHOTO_BASE64 = canvas.toDataURL();
		  	}
            
        }
        reader.readAsDataURL(fileInput.target.files[0]);
  	}

  	buildForm() {
    	this.formPersonal = this.formBuilder.group({
	      NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
	      LAST_NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
	      MOTHER_LAST_NAME: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
	      DATE_OF_BIRTH: this.formBuilder.control(null),
	      START_DATE: this.formBuilder.control(null),
	      CIVIL_STATUS: this.formBuilder.control(null),
	      GENDER: this.formBuilder.control(null, [Validators.required]),
	      RFC: this.formBuilder.control(null, [Validators.required, Validators.maxLength(20)]),
	      CURP: this.formBuilder.control(null, [Validators.maxLength(20)]),
	      MILITARY: this.formBuilder.control(null, [Validators.maxLength(20)]),
	      IMSS: this.formBuilder.control(null, [Validators.maxLength(20)]),
	      COUNTRY_ID: this.formBuilder.control(null),
	      STATE_ID: this.formBuilder.control(null),
	      CITY_ID: this.formBuilder.control(null),
	      ADDRESS: this.formBuilder.control(null, [Validators.maxLength(100)]),
	      COUNTY: this.formBuilder.control(null, [Validators.maxLength(101)]),
	      ZIP_CODE: this.formBuilder.control(null, [Validators.maxLength(30)]),
	      HOME_PHONE: this.formBuilder.control(null, [Validators.maxLength(20)]),
	      CELL_PHONE: this.formBuilder.control(null, [Validators.maxLength(20)]),
	      EMAIL: this.formBuilder.control(null, [Validators.maxLength(101)]),
	      Text1: this.formBuilder.control(null, [Validators.maxLength(500)]),
	      EMPLOYEE_NUMBER: this.formBuilder.control(null, [Validators.maxLength(30)]),
	      EMPLOYEE_TYPE: this.formBuilder.control(null, [Validators.required]),
	      AR_CUSTOMER: this.formBuilder.control(null, [Validators.required]),
	      // PERIODICITY: this.formBuilder.control(null),
	      // AMOUNT: this.formBuilder.control(null, [Validators.maxLength(11)]),
	      SHIRT_SIZE: this.formBuilder.control(null, [Validators.maxLength(45)]),
	      JEANS_SIZE: this.formBuilder.control(null, [Validators.maxLength(45)]),
	      SHOE_SIZE: this.formBuilder.control(null, [Validators.maxLength(45)]),
	      // Informacion de nomina y asistencia
	      WAY_TO_PAY: this.formBuilder.control(null),
	      CARD_NUMBER: this.formBuilder.control(null,[Validators.maxLength(20)]),
	      AMOUNT: this.formBuilder.control(null, [Validators.maxLength(11)]),
	      PRIZE: this.formBuilder.control(null, [Validators.maxLength(11)]),
	      DAY_OF_REST: this.formBuilder.control(null),
	      WORKSHIFT: this.formBuilder.control(null),
	      // IS_PENSIONER: this.formBuilder.control(null),
	      IMSS_TAX: this.formBuilder.control(null, [Validators.maxLength(11)]),
	      INFONAVIT: this.formBuilder.control(null, [Validators.maxLength(11)]),
	      PAY_IMSS: this.formBuilder.control(null),
	      INFONAVIT_FLAG: this.formBuilder.control(null),
	      REASON_NOT_IMSS: this.formBuilder.control(null),
	      SITE_ID: this.formBuilder.control(null),
    	});

    	this.formPersonal.get('CARD_NUMBER').disable();
    }

  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight) && this.itemsShow < this.list.Customer.length) {
      this.itemsShow += 10;
      this.viewDataPersonal = this.list.Customer.slice(0, this.itemsShow);
    }
  }
  /***************************INFINITE SELECT**********************************/
}


// WEBPACK FOOTER //
// ./src/app/personal/agregar-editar/personal-detalle.component.ts